module.exports = __webpack_public_path__ + "img/shopping-bag.40faaf1b.svg";